// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__24mBk","blurBox":"styles_blurBox__sp5-5","container":"styles_container__2RQhx"};